import { useEffect, useState } from "react";

// Always true GMT (UTC+0), all year — by design this runs an hour behind UK clocks during summer time.
const timeFmt = new Intl.DateTimeFormat("en-GB", {
  timeZone: "UTC",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export const useGmtTime = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let t;
    const tick = () => {
      setNow(new Date());
      t = setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    t = setTimeout(tick, 1000 - (Date.now() % 1000));
    return () => clearTimeout(t);
  }, []);
  return { time: timeFmt.format(now), iso: now.toISOString() };
};

export const UKClock = () => {
  const { time, iso } = useGmtTime();
  return (
    <div className="rise flex flex-col gap-2" data-testid="hero-clock-block">
      <p className="flex items-center gap-3 font-mono text-[13px] sm:text-sm text-gold">
        <span className="pulse-dot inline-block h-2 w-2 rounded-full bg-gold text-gold" aria-hidden="true" />
        <time data-testid="hero-clock" dateTime={iso} aria-label={`${time} GMT`} className="tabular-nums text-lg sm:text-xl font-medium tracking-tight">
          {time}
        </time>
        <span className="text-mist uppercase tracking-[0.18em] text-[11px]" data-testid="hero-clock-zone">GMT</span>
      </p>
      <p className="font-mono text-sm sm:text-base text-paper/85" data-testid="hero-clock-line">
        — Something&rsquo;s just broken.<span className="blink text-gold" aria-hidden="true">_</span>
      </p>
    </div>
  );
};
